import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

// Cart delivery-option selection needs a newer version than the site-wide 2023-01.
export const APPLE_PAY_API_VERSION = '2024-10';

// Stelcore Storefront carts return Standard shipping; destination tax is
// overlaid from Admin draftOrderCalculate (Storefront totalTaxAmount stays null).
// AE stays in STORE_TO_EXPRESS_STORE below; add it here to turn the button back on.
export const APPLE_PAY_SUPPORTED_STORES: ShopifyStore[] = [
  ShopifyStore.US,
  ShopifyStore.EU,
  ShopifyStore.GB,
];

// Backend naming is inverted: 'stelcore' = USA, 'us' = rest-of-world.
export const STORE_TO_EXPRESS_STORE: Partial<Record<ShopifyStore, string>> = {
  [ShopifyStore.US]: 'stelcore',
  [ShopifyStore.EU]: 'eu_uk',
  [ShopifyStore.GB]: 'eu_uk',
  [ShopifyStore.AE]: 'uae',
};

export const STORE_TO_COUNTRY: Record<string, string> = {
  [ShopifyStore.US]: 'US',
  [ShopifyStore.CA]: 'CA',
  [ShopifyStore.EU]: 'DE',
  [ShopifyStore.GB]: 'GB',
  [ShopifyStore.AE]: 'AE',
  [ShopifyStore.AU]: 'AU',
  [ShopifyStore.SA]: 'SA',
  [ShopifyStore.MX]: 'MX',
  [ShopifyStore.ZA]: 'ZA',
};

// Must match each store's Shopify market currency (see getStoreConfig).
export const STORE_TO_CURRENCY: Record<string, string> = {
  [ShopifyStore.US]: 'USD',
  [ShopifyStore.CA]: 'CAD',
  [ShopifyStore.EU]: 'EUR',
  [ShopifyStore.GB]: 'GBP',
  [ShopifyStore.AE]: 'AED',
  [ShopifyStore.AU]: 'AUD',
  [ShopifyStore.SA]: 'SAR',
  [ShopifyStore.MX]: 'MXN',
  [ShopifyStore.ZA]: 'ZAR',
};

// Build-time kill switch, defaults OFF.
export const isApplePayEnabled = (): boolean =>
  process.env.NEXT_PUBLIC_APPLE_PAY_ENABLED === 'true';

export const isApplePaySupportedStore = (
  store: ShopifyStore | null | undefined,
): boolean => {
  if (!store) return false;
  return APPLE_PAY_SUPPORTED_STORES.includes(store);
};

// Must match the account the backend creates PaymentIntents on — the wallet
// sheet has to be built from the same account that gets confirmed.
export const STRIPE_PUBLISHABLE_KEY_BY_STORE: Record<string, string | undefined> =
  {
    [ShopifyStore.US]: process.env.NEXT_PUBLIC_STRIPE_US_PUBLISHABLE_KEY,
    [ShopifyStore.CA]: process.env.NEXT_PUBLIC_STRIPE_US_PUBLISHABLE_KEY,
    [ShopifyStore.EU]: process.env.NEXT_PUBLIC_STRIPE_EU_PUBLISHABLE_KEY,
    [ShopifyStore.GB]: process.env.NEXT_PUBLIC_STRIPE_EU_PUBLISHABLE_KEY,
    [ShopifyStore.AE]: process.env.NEXT_PUBLIC_STRIPE_AE_PUBLISHABLE_KEY,
    [ShopifyStore.AU]: process.env.NEXT_PUBLIC_STRIPE_EU_PUBLISHABLE_KEY,
    [ShopifyStore.SA]: process.env.NEXT_PUBLIC_STRIPE_EU_PUBLISHABLE_KEY,
    [ShopifyStore.MX]: process.env.NEXT_PUBLIC_STRIPE_EU_PUBLISHABLE_KEY,
    [ShopifyStore.ZA]: process.env.NEXT_PUBLIC_STRIPE_EU_PUBLISHABLE_KEY,
  };
